var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bannerUrl.length!==0)?_c('v-carousel',{staticClass:"mt-2",staticStyle:{"border-radius":"8px"},attrs:{"show-arrows":_vm.bannerUrl.length!==1,"hide-delimiters":"","cycle":"","height":"auto"}},_vm._l((_vm.bannerUrl),function(item,i){return _c('v-carousel-item',{key:i,staticClass:"c-banner",attrs:{"src":item.link_url}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }